/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SignUpUserComponent} from "./sign-up-user/sign-up-user.component";
import {logoutResolver} from "../resolvers/logout-resolver";

const routes: Routes = [{
  path: '',
  component: SignUpUserComponent,
  resolve: {logout: logoutResolver},
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignupUserFeatureRoutingModule {
}
